import React, { useState, useEffect } from 'react'
import { useBranchofficesByEvent } from '../../context/BranchofficesByEventContext';
import { useNavigate, useParams } from 'react-router-dom';
//Component
import { BarMenu } from '../common/BarMenu/BarMenu'
import { Header } from '../common/Header/Header'

import Maps from '../../utils/Maps';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import MapsWithRoute from '../../utils/MapsWithRoute';

import { Modal } from 'react-bootstrap/Modal';
//css

import './branch.css'

import ModalLoginUserClient from '../../layouts/Kiosk_ecommers_stant/ModalLoginUserClient';
import ModalDetailUser from '../../layouts/Kiosk_ecommers_stant/ModalDetailuser';
import ErrorAlert from '../Alerts/ErrorAlert';
import AlertSmall from '../Alerts/AlertSmall';
import ModalWelcomePage from '../../layouts/Kiosk_ecommers_stant/ModalWelcomePage';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { BusinessFetchAPI } from '../../api/Business';
import { AuthFetchAPI } from '../../api/Auth';
import { PrinterFetchAPI } from '../../api/Printer';
import { MachinesFetchAPI } from '../../api/Machines';
import { ClientsFetchAPI } from '../../api/Clients';
import { TablesFetchAPI } from '../../api/Tables';
import { ParthnerFetchAPI } from '../../api/Parthner';
import { EventsFetchAPI } from '../../api/Events';
import LoginStand from '../Profile/LoginStand';
import ModalAddressClient from '../Profile/Modals/ModalAddressClient';
import { getDireccionMasCercana } from '../../utils/AddressLocation';
import { getCurrentCoords } from '../../utils/Maps';
//Icons
import { MenuBar } from '../../layouts/Kiosk_ecommers_stant/components/MenuBar/MenuBar';
import Loader from '../Home/Loader';
import HeaderMain from '../Home/Headers/HeaderMain';
import { isActiveTableSessionStatus, useTableSession } from '../../context/TableSessionContext';

const getStoredBusiness = () => {
    try {
        const business = localStorage.getItem("business")
        return business && business !== "undefined" && business !== "null" ? JSON.parse(business) : null
    } catch (err) {
        return null
    }
}

function BranchSelectNew() {
    const { type, profile, order_code } = useParams();
    const [tableCode, settableCode] = useState();
    const [business_code, setBusiness_code] = useState(() => {
        const business = getStoredBusiness()
        return business?.code
    });

    // Usar el contexto para branchofficesByEvent
    const { branchofficesByEvent, setBranchofficesByEvent } = useBranchofficesByEvent();
    const [eventsEnabled, setEventsEnabled] = useState(() => {
        const business = getStoredBusiness();
        return business?.events_enabled === 1;
    });


    const [showModalWelcomePage, setShowModalWelcomePage] = useState(false)
    const [modalStand, setModalStand] = useState(false)
    const [branchoffices, setBranchoffices] = useState([])
    const [allBranchoffices, setAllBranchoffices] = useState([])
    const [branchNotice, setBranchNotice] = useState('')
    const [background, setBackground] = useState('')
    const [businessinfo, setBusinessinfo] = useState({ id: 0 })
    const [showModal, setShowModal] = useState(false);
    const [showModalDetail, setShowModalDetail] = useState(false);
    const [dataClient, setDataClient] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            return JSON.parse(localStorage.getItem('client'))
        } else {
            return { client_name: 'Soy usuario', client_id: '0', client_ruc: "0000-00", client_ruc: "00" }
        }
    })
    const [dataTable, setDataTable] = useState({ name: 'Soy un stan' })
    const [pageLoader, setPageLoader] = useState(0)
    const [clients, setClients] = useState([])
    //const [tables, setTables] = useState([]);
    const [typeUser, setTypeUser] = useState('')
    const [token, setToken] = useState('')
    const [parthners, setParthners] = useState([])
    const [logo, setLogo] = useState('')
    const [tableNow, setTableNow] = useState({ label: "" })
    const [eventHandler, setEventHandlers] = useState(0)


    //Address
    const [modalAddPoints, setModalAddPoints] = useState(false);
    const [addressNowLocation, setAddressNowLocation] = useState(() => {
        if (localStorage.getItem('addressNowLocation') != null && localStorage.getItem('addressNowLocation') != undefined && localStorage.getItem('addressNowLocation') != '') {
            return JSON.parse(localStorage.getItem('addressNowLocation'))
        } else {
            return null
        }
    });
    const [addressClient, setAddressClient] = useState([])
    const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });

    //get address by client
    const getAddressClientNow = async () => {
        try {
            const response = await ClientsFetchAPI.getAddressClient(dataClient.id, token);
            setAddressClient(response.data.data)


            let direction = getDireccionMasCercana(response.data.data, coordinates)
            //setAddressNowLocation(direction)

        } catch (err) {
            setAddressClient([])

        }
    }


    const navigate = useNavigate();
    const {
        loading: tableSessionLoading,
        session: tableSession,
        status: tableSessionStatus,
    } = useTableSession();
    const tableSessionHasEcommerceContext = Boolean(
        tableSession?.business?.id &&
        tableSession?.branchoffice?.id &&
        tableSession?.machine?.id
    );
    const hasActiveTableSession = isActiveTableSessionStatus(tableSessionStatus) && tableSessionHasEcommerceContext;

    const preventTableBranchChange = () => {
        if (!hasActiveTableSession) return false;

        AlertSmall('La sesion de mesa mantiene la sucursal actual.', 'warning');
        navigate('/menu');
        return true;
    }

    let count = 0
    let lengthArrayRestaurant = 0
    let arrayTempBranch1 = []
    let arrayTempBranch2 = []
    const validLengthArrayRestaurant = (data, request) => {

        if (type != "true" && tableCode == undefined) {

            lengthArrayRestaurant = (lengthArrayRestaurant + data.length)
            count = count + 1



            if (request == 1) {
                arrayTempBranch1 = data
            } else {
                arrayTempBranch2 = data
            }

            if (count == 2) {

                if (lengthArrayRestaurant == 1) {

                    handleSave(arrayTempBranch1)
                } else {

                }

                arrayTempBranch1 = []
                arrayTempBranch2 = []
                count = 0
                lengthArrayRestaurant = 0
            }
        }
    }


    const validKeyproduct = (branchResult) => {

        let branch_id = localStorage.getItem('product').split("X")[1]


        let databranch = branchResult.find((branch) => branch.branchofficeId == branch_id)

        if (databranch !== undefined) {
            handleSaveBranchoffice(databranch)
        } else {
            //localStorage.removeItem('product')
            ErrorAlert('', 'La sucursal del producto no se encontro', 'warning')
        }
    }

    const isEventsFlowEnabled = (business) => {
        if (business) {
            return business.events_enabled === 1 || business.events_enabled === true
        }

        return eventsEnabled === 1 || eventsEnabled === true
    }

    const parseSelectedEventCache = () => {
        const selectedEvent = localStorage.getItem('dataEvent')
        if (!selectedEvent || selectedEvent === 'undefined' || selectedEvent === 'null') {
            return null
        }

        try {
            return JSON.parse(selectedEvent)
        } catch (err) {
            return null
        }
    }

    const getBranchId = (branch) => {
        return branch?.branchofficeId
            ?? branch?.branchoffice_id
            ?? branch?.branchOfficeId
            ?? branch?.branch_office_id
            ?? branch?.branchId
            ?? branch?.branch_id
            ?? branch?.sucursalId
            ?? branch?.sucursal_id
            ?? branch?.branchoffice?.id
            ?? branch?.branch?.id
            ?? branch?.sucursal?.id
            ?? branch?.id
            ?? null
    }

    const getBranchCode = (branch) => {
        return branch?.branchoffice_code
            ?? branch?.branchofficeCode
            ?? branch?.branchOfficeCode
            ?? branch?.branch_office_code
            ?? branch?.branchCode
            ?? branch?.branch_code
            ?? branch?.sucursalCode
            ?? branch?.sucursal_code
            ?? branch?.branchoffice?.code
            ?? branch?.branch?.code
            ?? branch?.sucursal?.code
            ?? branch?.code
            ?? null
    }

    const stopBranchSelectionUntilEvent = () => {
        setBranchoffices([])
        setBranchNotice('Selecciona un evento para ver las sucursales disponibles.')
        validLengthArrayRestaurant([], 1)
        setEventHandlers(1)
    }

    const showEmptyEventBranches = () => {
        setBranchoffices([])
        setBranchNotice('Este evento no tiene sucursales disponibles.')
        validLengthArrayRestaurant([], 1)
        setEventHandlers(1)
    }

    const getTempOrderById = async (token) => {


        if (localStorage.getItem("PreOrder") != "" && localStorage.getItem("PreOrder") != undefined) {
            let PreOrder = localStorage.getItem("PreOrder");
            try {
                const response = await PrinterFetchAPI.getTempOrderByPrint(token, PreOrder);
                let orderOnlineData = response.data.order_to_impress[0].orders_to_impress[0]
                let branchCodePreOrder = orderOnlineData.branchoffice.code

                getBranchOfficeByCode(branchCodePreOrder, token, orderOnlineData)


            } catch (err) {

            }
        } else {

        }
    }

    const filterBranchByEvent = (dataBranch, dataEvent, business) => {
        const idsEvento = new Set(
            dataEvent
                .map(getBranchId)
                .filter((id) => id !== null && id !== undefined && id !== '')
                .map(String)
        );
        const codesEvento = new Set(
            dataEvent
                .map(getBranchCode)
                .filter((code) => code !== null && code !== undefined && code !== '')
                .map(String)
        );

        if (!idsEvento.size && !codesEvento.size) {
            showEmptyEventBranches()
            setBranchofficesByEvent(dataEvent);
            return
        }

        const sucursalesFiltradas = dataBranch.filter((branch) => {
            const branchId = getBranchId(branch)
            const branchCode = getBranchCode(branch)
            return (
                (branchId !== null && branchId !== undefined && idsEvento.has(String(branchId))) ||
                (branchCode !== null && branchCode !== undefined && codesEvento.has(String(branchCode)))
            )
        });

        processBranch(sucursalesFiltradas, business, { fromEvent: true })
        setBranchofficesByEvent(dataEvent);
    }

    const processBranch = (data, business, options = {}) => {
        if (isEventsFlowEnabled(business) && !parseSelectedEventCache()) {
            stopBranchSelectionUntilEvent()
            return
        }

        let branchResult = data.filter((branch) => branch.state === 1 && branch.ecommerce === 1);

        if (isEventsFlowEnabled(business) && options.fromEvent && branchResult.length === 0) {
            setBranchNotice('Este evento no tiene sucursales ecommerce disponibles.')
        } else {
            setBranchNotice('')
        }

        setBranchoffices(branchResult)
        if (!isEventsFlowEnabled(business)) {
            validLengthArrayRestaurant(branchResult, 1)
        }
        setEventHandlers(1)


        if (localStorage.getItem('product') != null && localStorage.getItem('product') != undefined && localStorage.getItem('product') != '') {
            validKeyproduct(branchResult)
        } else {
            if (branchResult.length == 1) {
                handleSaveBranchoffice(branchResult[0])
            } else {
                validToken(0, true, business);
            }
        }
    }

    const parseBranchEventCache = (branchEvent) => {
        if (!branchEvent || branchEvent === 'undefined' || branchEvent === 'null') {
            return []
        }

        try {
            const parsedBranchEvent = JSON.parse(branchEvent)
            return Array.isArray(parsedBranchEvent) ? parsedBranchEvent : []
        } catch (err) {
            return []
        }
    }

    const hasUsableToken = (value) => {
        return value && value !== 'undefined' && value !== 'null'
    }

    const ensurePublicToken = async (business) => {
        if (!business?.id) {
            return ''
        }

        try {
            const response = await AuthFetchAPI.validToken()
            if (response.data === true) {
                setToken('')
                return true
            }
        } catch (err) {
            // Generate a fresh public token below.
        }

        try {
            const response = await AuthFetchAPI.generatePublicToken(business.id)
            if (response?.data?.success === false) return ''
            // The cookie this endpoint also sets is cross-origin (frontend and API live on
            // different hosts) - browsers increasingly refuse to store/send third-party cookies
            // (always in Incognito/InPrivate), so relying on it alone leaves every subsequent
            // "public" call with no credentials at all, 401ing forever. The response already
            // carries the same token in its body - use that explicitly via x-access-token instead.
            // Returned directly (not just via setToken) because the very next call in
            // branchByBusines needs it in THIS same tick - setToken's state update wouldn't be
            // visible yet if read back from the `token` closure variable right after.
            const freshToken = response?.data?.token || ''
            setToken(freshToken)
            return freshToken || true
        } catch (err) {
            return ''
        }
    }

    const getEventBranchesForSelection = async (selectedEvent, business) => {
        if (!selectedEvent?.id || !business?.id) {
            return []
        }

        const cachedBranches = parseBranchEventCache(localStorage.getItem('branchofficesByEvent'))
        const fallbackBranches = cachedBranches.length > 0
            ? cachedBranches
            : Array.isArray(branchofficesByEvent)
                ? branchofficesByEvent
                : []

        try {
            const eventToken = await ensurePublicToken(business)
            if (!eventToken) return fallbackBranches

            const response = await EventsFetchAPI.getBranchByEvent(selectedEvent.id)
            const eventBranches = response?.data?.branchoffices?.length
                ? response.data.branchoffices
                : fallbackBranches

            if (eventBranches.length > 0) {
                setBranchofficesByEvent(eventBranches)
                setBranchNotice('')
            } else {
                setBranchNotice('Este evento no tiene sucursales disponibles.')
            }

            return eventBranches
        } catch (err) {
            if (fallbackBranches.length === 0) {
                setBranchNotice('No se pudieron cargar las sucursales del evento. Revisa si el navegador bloqueó la petición.')
            }
            return fallbackBranches
        }
    }

    const branchByBusines = async (business) => {

        try {
            const publicToken = await ensurePublicToken(business)
            if (!publicToken) {
                setBranchoffices([])
                setBranchNotice('No fue posible iniciar la sesión pública para cargar sucursales.')
                validLengthArrayRestaurant([], 1)
                setEventHandlers(1)
                return
            }

            const response = await BranchOfficeFetchAPI.getBranchOfficesByBusiness(business.id, publicToken === true ? token : publicToken)
            let branchs = response.data.data
            setAllBranchoffices(branchs)
            let branchEvent = localStorage.getItem('branchofficesByEvent')
            let selectedEvent = parseSelectedEventCache()
            let jsonBranchEvent = parseBranchEventCache(branchEvent)

            if (isEventsFlowEnabled(business)) {
                if (!selectedEvent) {
                    localStorage.removeItem('branchofficesByEvent')
                    setBranchofficesByEvent(null)
                    stopBranchSelectionUntilEvent()
                    return
                }

                let eventBranches = await getEventBranchesForSelection(selectedEvent, business)

                if (eventBranches.length === 0) {
                    eventBranches = jsonBranchEvent.length > 0
                    ? jsonBranchEvent
                    : Array.isArray(branchofficesByEvent)
                        ? branchofficesByEvent
                        : []
                }

                if (eventBranches.length > 0) {
                    filterBranchByEvent(branchs, eventBranches, business)
                } else {
                    setBranchoffices([])
                    validLengthArrayRestaurant([], 1)
                    setEventHandlers(1)
                }

                return
            }

            localStorage.removeItem('branchofficesByEvent')
            setBranchofficesByEvent(null)
            processBranch(branchs, business)
        } catch (err) {
            validLengthArrayRestaurant([], 1)

        }
    }

    //save and select parthner
    const selectRestaurant = (data) => {
        if (preventTableBranchChange()) return;

        validToken(0, false, businessinfo);
        clearBranchDependentCache();

        let jsonNewParthner = { id: data.parthner_branchoffice_id, name: data.parthner_name, code: data.code, branchoffice_open: null, branchoffice_printer: null, branchoffice_support_phone: data.phone }
        localStorage.setItem('branchoffice', JSON.stringify(jsonNewParthner))

        if (data.parthner_branch_machine_id !== null) {
            getInfoMachine(data.parthner_branch_machine_id, data)
        }

        localStorage.setItem('logo', data.logo)
    }

    //function get machine info
    const getInfoMachine = async (machine_id, dataBranchoffice) => {

        try {
            const response = await MachinesFetchAPI.getmachineByid(machine_id, token)
            let infoMachineJson = response.data.data


            let jsonNewMachine = {
                id: infoMachineJson.machine_per_branch_id,
                code: infoMachineJson.code,
                is_logged: 0,
                name_type_machine: infoMachineJson.name_type_machine,
                machine_type_id: infoMachineJson.machine_type_id,
                printers: infoMachineJson.printers,
                machine_config: infoMachineJson.machine_config
            }

            localStorage.setItem('machine', JSON.stringify(jsonNewMachine));
            localStorage.setItem('parthner_order', true);
            if (localStorage.getItem("product") !== null && localStorage.getItem("product") !== undefined && localStorage.getItem("product") !== "") {
                navigate(`/cart/product/${localStorage.getItem("product")}`)
            } else {

                if (profile === "true") {
                    navigate(`/profile`)
                } else if (order_code !== undefined && order_code !== null) {
                    navigate(`/home/quote/${order_code}`)
                } else {
                    navigate(`/home`)
                }
            }

        } catch (err) {

        }
    }



    const getBusinessByCode = async () => {
        try {
            const response = await BusinessFetchAPI.getBusinessByCode(business_code)

            localStorage.setItem('logo', response.data.businessConfig.logo);
            setLogo(response.data.businessConfig.logo)
            setBackground(response.data.businessConfig.background)

            let dataBusiness = {
                "id": response.data.business.id,
                "name": response.data.business.name,
                "description": response.data.business.description,
                "code": response.data.business.code,
                "config": null,
                "events_enabled": response.data.business.events_enabled
            }
            setEventsEnabled(response.data.business.events_enabled === 1)
            setBusinessinfo(dataBusiness)
            localStorage.setItem('businessConfig', JSON.stringify(response.data.businessConfig))
            localStorage.setItem("frecuentShopperConfig", response.data.frecuentShopperConfig !== null ? JSON.stringify(response.data.frecuentShopperConfig) : null);
            localStorage.setItem('business', JSON.stringify(dataBusiness))
            await ensurePublicToken(dataBusiness)
            branchByBusines(dataBusiness);


        } catch (err) {
            if (profile === "true") {
                navigate(`/home/${true}`)
            } else if (order_code !== undefined && order_code !== null) {
                navigate(`/home/quote/${order_code}`)
            } else {
                navigate(`/home`)
            }

        }
    }

    const getBranchOfficeByCode = async (branchoffice_code, token, orderOnlineData) => {
        try {
            const response = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, branchoffice_code, token)
            let branchoffice_info = response.data.branchoffice
            let machine_ecommerce = response.data.branchoffice.machine_ecommerce
            let machine_table = response.data.branchoffice.machine_table
            let data_branchoffice = {
                "id": branchoffice_info.id,
                "name": branchoffice_info.name,
                "code": branchoffice_info.code,
                "order_printed": branchoffice_info.printed_order,
                "branchoffice_printer": branchoffice_info.printer_name,
                "branchoffice_support_phone": branchoffice_info.supportPhone,
                "branchoffice_open": branchoffice_info.branchoffice_open,
                'machine_ecommerce': machine_ecommerce,
                'machine_table': machine_table
            }

            if (machine_ecommerce !== null) {
                if (machine_ecommerce.length > 0) {
                    getMachineByCode(branchoffice_code, token, machine_ecommerce[0].code, orderOnlineData)
                } else {
                    ErrorAlert('', 'Esta sucursal no tiene eccomerce', 'warning')
                }
            } else {
                ErrorAlert('', 'Esta sucursal no tiene eccomerce', 'warning')
            }


            localStorage.setItem('branchoffice', JSON.stringify(data_branchoffice));
            localStorage.setItem('branchoffice_original', JSON.stringify(data_branchoffice));


        } catch (err) {
        }


    }


    const generateToken = async (branchoffice_code, stateModalLog, dataBusiness) => {


        let business_id = 0
        if (dataBusiness === undefined) {
            business_id = businessinfo.id;
        } else {
            business_id = dataBusiness.id
        }

        try {
            const response = await AuthFetchAPI.generatePublicToken(business_id);
            if (response?.data?.success === false) return;

            // Same fix as ensurePublicToken above: use the token this response carries in its body
            // explicitly (via x-access-token) instead of only relying on the cookie it also sets -
            // that cookie is cross-origin and browsers increasingly refuse to store/send third-party
            // cookies (always the case in Incognito/InPrivate), which left getBranchOfficeByCode and
            // everything it chains into (getMachineByCode) with no credentials at all.
            const freshToken = response?.data?.token || ''
            setToken(freshToken)
            // get data preorder
            getTempOrderById()

            //getParthners()
            //getTablesByBusiness(business_id)
            if (stateModalLog !== true) {
                getBranchOfficeByCode(branchoffice_code, freshToken)
            }



        } catch (err) {
        }
    }

    const datasetCoords = () => {
        getCurrentCoords()
            .then(coords => {
                // coords.lat y coords.lng disponibles aquí
                setCoordinates({ lat: coords.lat, lng: coords.lng });
            })
            .catch(err => {
                // Manejo de error

            });
    }

    const validToken = async (branchoffice_code, stateModalLog, dataBusiness) => {

        datasetCoords()
        try {
            const response = await AuthFetchAPI.validToken();

            if (response.data === true) {

                setToken('');


                getTempOrderById()


                if (stateModalLog !== true) {
                    getBranchOfficeByCode(branchoffice_code)
                }
            } else {
                generateToken(branchoffice_code, stateModalLog, dataBusiness)
            }
        } catch (err) {
            generateToken(branchoffice_code, stateModalLog, dataBusiness)
        }
    }



    const getMachineByCode = async (branchoffice_code, token, machine_code, orderOnlineData) => {
        try {
            const response = await MachinesFetchAPI.getMachineByCode(machine_code, branchoffice_code, token);
            let machines_info = response.data.machine
            let data = {
                "id": machines_info.id,
                "code": machines_info.code,
                "is_logged": machines_info.is_logged,
                "name_type_machine": machines_info.name_type_machine,
                "machine_type_id": machines_info.machine_type_id,
                "printers": [],
                "machine_config": {
                    "mainContainer": true,
                    "deliveryGroup": {
                        "actvPlus": true
                    },
                    "buttons": {
                        "groupPlus": true,
                        "groupLite": false,
                        "menu": {
                            "groupPlus": true,
                            "topNav": false,
                            "actvLite": false
                        },
                        "discounts": {
                            "actvPlus": true,
                            "actvLite": false
                        },
                        "coupons": {
                            "actvPlus": true,
                            "actvLite": false
                        },
                        "pendingOrders": {
                            "actvPlus": true,
                            "actvLite": false
                        },
                        "return": {
                            "actvPlus": true,
                            "actvLite": false
                        }
                    }
                },
                "machine_open": machines_info.machine_open
            }

            localStorage.setItem('machine', JSON.stringify(data));
            localStorage.setItem('parthner_order', false);

            if (orderOnlineData !== undefined) {
                navigate(`/cart/order/${orderOnlineData.code}/${localStorage.getItem("PreOrder")}`)
            } else {

                if (localStorage.getItem("product") !== null && localStorage.getItem("product") !== undefined && localStorage.getItem("product") !== "") {
                    navigate(`/cart/product/${localStorage.getItem("product")}`)
                } else {
                    if (profile === "true") {
                        navigate(`/profile`)
                    } else if (order_code !== undefined && order_code !== null) {
                        navigate(`/home/quote/${order_code}`)
                    } else {
                        navigate(`/home`)
                    }

                }

            }


        } catch (err) {
        }
    }



    const getTablesByBusiness = async (businessinfo_id, token) => {

        if (tableCode != undefined) {
            try {
                const response = await TablesFetchAPI.getBusinessTables(businessinfo_id, token);

                let tablesInfo = []
                response.data.tables.forEach(table => {
                    if (table.status === 1) { tablesInfo.push({ value: table, label: table.name }) }
                });



                //ROOOM SERVICE
                let filterTable = tablesInfo.find((table) => table.value.table_code === tableCode)
                let codeRoom = localStorage.getItem('codeRoom')


                if (filterTable != undefined) {
                    setTableNow(filterTable)
                    if (filterTable.value.open_order == 1) {

                        setShowModalWelcomePage(false)
                        localStorage.setItem('table', JSON.stringify(filterTable.value))
                        localStorage.setItem('codeRoom', filterTable.value.password)

                    } else {
                        if (codeRoom != undefined || codeRoom != '' || codeRoom != null) {
                            if (codeRoom == filterTable.value.password) {
                                setShowModalWelcomePage(true)
                                localStorage.setItem('table', JSON.stringify(filterTable.value))
                            } else {
                                setShowModalWelcomePage(false)
                                setModalStand(true)
                            }
                        } else {
                            setShowModalWelcomePage(false)
                            setModalStand(true)
                        }
                    }

                }
                //----------------------------------------------
                //setTables(tablesInfo);
            } catch (err) {
                //console.log(err);
            }
        }
    }


    const getClientsByBusiness = async (businessinfo_id) => {

        try {

            const response = await ClientsFetchAPI.getClientsByBusiness(businessinfo_id, token)
            setClients(response.data.data)
        } catch (err) {
            setClients([])
        }
    }


    const handleModalSesionValid = (typeUser) => {

        if (typeUser === 'stan') {
            if (dataTable.name === 'Soy un stan') {
                setShowModal(true)

                setTypeUser(typeUser)
                getTablesByBusiness()
            } else {
                setShowModalDetail(true)
            }
        } else if (typeUser === 'client') {
            if (dataClient.client_name === 'Soy usuario') {
                setShowModal(true)

                setTypeUser(typeUser)
                getClientsByBusiness()
            } else {
                setShowModalDetail(true)
            }
        }

    }


    const handleSaveBranchoffice = (branchoffice, PreOrderCode) => {
        if (preventTableBranchChange()) return;

        clearBranchDependentCache();

        let data = {
            "id": branchoffice.branchofficeId,
            "name": branchoffice.branchofficeName,
            "code": branchoffice.branchoffice_code,
            "order_printed": 0,
            "branchoffice_printer": null,
            "branchoffice_support_phone": "",
            "branchoffice_open": 1
        };

        localStorage.setItem('branchoffice', JSON.stringify(data));
        const currentBusiness = getStoredBusiness() || businessinfo;
        validToken(branchoffice.branchoffice_code, false, currentBusiness);
    }

    const clearParamslocal = () => {
        localStorage.removeItem('x-access-machine-token')
        localStorage.setItem('branchoffice', '')
        localStorage.setItem('machine', '')
        localStorage.setItem('business', '')
        localStorage.setItem('logo', '')
        localStorage.setItem('parthner_order', '')
        localStorage.setItem('selectedCategorie', '')
    }

    const clearBranchDependentCache = () => {
        localStorage.removeItem('machine')
        localStorage.removeItem('machine_original')
        localStorage.removeItem('generalData')
        localStorage.removeItem('publicity')
        localStorage.removeItem('Detail_order')
        localStorage.removeItem('selectedCategorie')
        localStorage.removeItem('table')
        localStorage.removeItem('codeRoom')
    }

    const handleSave = (data) => {
        if (preventTableBranchChange()) return;

        let branchofficeArray = []
        if (data !== undefined) {
            branchofficeArray = data
        } else {
            branchofficeArray = branchoffices
        }

        if (branchofficeArray.length > 0) {

            handleSaveBranchoffice(branchofficeArray[0])
        }
        else {
            setShowModalWelcomePage(false)
        }
    }


    useEffect(() => {
        if (tableSessionLoading) return;

        if (hasActiveTableSession) {
            AlertSmall('La sesion de mesa mantiene la sucursal actual.', 'warning');
            navigate('/menu');
            return;
        }

        clearParamslocal()
        getBusinessByCode();
        setPageLoader(0)
    }, [pageLoader, hasActiveTableSession, tableSessionLoading])

    useEffect(() => {
        let lastValue = localStorage.getItem('branchofficesByEvent');
        const interval = setInterval(() => {
            const currentValue = localStorage.getItem('branchofficesByEvent');
            if (currentValue !== lastValue) {
                lastValue = currentValue;
                let business = getStoredBusiness()
                let selectedEvent = parseSelectedEventCache()
                const sucursalesEvento = parseBranchEventCache(currentValue);
                const sourceBranches = allBranchoffices.length > 0 ? allBranchoffices : branchoffices

                if (isEventsFlowEnabled(business)) {
                    if (!selectedEvent) {
                        stopBranchSelectionUntilEvent()
                    } else if (sucursalesEvento.length > 0) {
                        filterBranchByEvent(sourceBranches, sucursalesEvento, business)
                    } else {
                        showEmptyEventBranches()
                    }
                } else if (business?.id) {
                    branchByBusines(business)
                }
            }
        }, 500); // revisa cada 500ms
        return () => clearInterval(interval);
    }, [allBranchoffices, branchoffices]);


    const [loading, setLoading] = useState(true);
    const requireEventBeforeBranches = isEventsFlowEnabled() && !parseSelectedEventCache()
    const canShowBranchOptions = !requireEventBeforeBranches
    const emptyBranchMessage = branchNotice || 'No hay Tiendas disponibles'

    return (
        <>


            {loading && <Loader onFinish={() => setLoading(false)} />}
            {!loading &&
                (<>

                    <div className="hero-wrapper ">
                        <HeaderMain />
                        <main>
                            <div className=' product-ecommerce-container'>
                                <div className='container d-flex justify-content-center align-items-center '>
                                    <div>
                                        <h4 className="py-lg-2 py-1 m-0">Restaurantes </h4>

                                    </div>
                                </div>
                            </div>




                            <main className=''>

                                <div className='container mt-2 mb-5'>
                                    <div className='row px-3'>

                                        <div className='col-md-12 row px-3'>



                                            {/* <------  ----->  */}
                                            {canShowBranchOptions && parthners.length > 0 ? <>
                                                {parthners.map((parthner) => (
                                                    <>

                                                        {/* Restaurantes  */}
                                                        <div className='col-6 col-md-3  p-2' onClick={() => selectRestaurant(parthner)}>
                                                            {/* Card */}
                                                            <label className="card-restaurant ">

                                                                <span class="badge badge-success rounded-2  position-absolute badge-position">Abierto</span>



                                                                <input name="plan" className="radio" type="radio" />

                                                                <span className="plan-details">

                                                                    <div className="d-flex justify-content-start">
                                                                        <img src={buildCloudinaryImageUrl({ url: parthner.logo, width: 300, quality: "auto", type: "image" })} loading="lazy"
                                                                            alt="Restaurant" className="rounded-2  border img-restaurant " />
                                                                    </div>
                                                                    <span className="plan-type" translate='no'>{parthner.branchoffice_name} </span>
                                                                    <p className="plan-description" translate='no'>{parthner.parthner_name}</p>

                                                                </span>
                                                            </label>

                                                        </div>
                                                    </>
                                                ))}</> : <></>}
                                            {
                                                !canShowBranchOptions || !branchoffices.length
                                                    ? <>
                                                        <div className='col-12 d-flex justify-content-center align-items-center border
                                             p-4 mt-5 bg-blur-sp-2 rounded-4'>
                                                            <h6 className='fw-bold text-dark text-center p-4'>
                                                                {emptyBranchMessage}
                                                            </h6>
                                                        </div>
                                                    </>
                                                    : <>
                                                        {branchoffices.map((branchoffice) => (
                                                            <>

                                                                <div className='col-6 col-md-3 p-2' onClick={() => handleSaveBranchoffice(branchoffice)}>
                                                                    {/* Card */}
                                                                    <label className="card-restaurant">

                                                                        <span class="badge badge-success rounded-2  position-absolute badge-position">Abierto</span>



                                                                        <input name="plan" className="radio" type="radio" />

                                                                        <span className="plan-details">

                                                                            <div className="d-flex justify-content-start">
                                                                                <img src={buildCloudinaryImageUrl({ url: logo, width: 300, quality: "auto", type: "image" })} loading="lazy"
                                                                                    alt="Restaurant" className=" img-restaurant " />
                                                                            </div>
                                                                            <span className="plan-type" translate='no'>{branchoffice.branchofficeName}</span>
                                                                            {branchoffice.distancia_km ? <><p className="plan-description" translate='no'>Distancia en kilometros: {branchoffice.distancia_km.toFixed(2)} KM </p></> : <></>}
                                                                            <p className="plan-description" translate='no'>{branchoffice.businessName}</p>

                                                                            <div className="d-flex gap-2">
                                                                                {branchoffice.closest && branchoffice.closest == true ? <>
                                                                                    <span class="badge bg-success text-white"> <i class="uil uil-location-pin-alt"></i> Restaurante mas cercano </span></> : <>
                                                                                    <span class="badge bg-light text-secondary">Restaurante </span></>}
                                                                            </div>
                                                                        </span>
                                                                    </label>

                                                                </div>
                                                            </>
                                                        ))}
                                                    </>
                                            }


                                        </div>
                                    </div>
                                </div>
                            </main>
                        </main>
                    </div>
                </>)
            }

            <main>




            </main>







            {type == "true" ? <></> : <>
                <ModalWelcomePage showModalWelcomePage={showModalWelcomePage} setShowModalWelcomePage={setShowModalWelcomePage} background={background} tableNow={tableNow} handleSaveBranchoffice={handleSaveBranchoffice} branchoffices={branchoffices} handleSave={handleSave}></ModalWelcomePage></>}
            <LoginStand modalStand={modalStand} setModalStand={setModalStand} tableNow={tableNow} background={background} handleSaveBranchoffice={handleSaveBranchoffice} branchoffices={branchoffices} />
        </>
    )
}

export default BranchSelectNew
